export const isEmptyObject = (obj: Record<string, any>) => Object.keys(obj).length === 0;
